module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BCLezj/tc-custom/9781634864985.jpg?1723405852834",
      "alt": "This image is the cover for the book Ravenous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ravenous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tall, intelligent and handsome, Hatch Lye is works for Ravenous, a company that tests cookbook recipes for publishing houses. At thirty-five, he’s pretty much settled in his ways."), _c('br'), _c('br'), _vm._v("Then unexpectedly, things change for him when he makes an afternoon coffee run. On the street corner, he meets a homeless man named Kevin Balk. They exchange smiles, a simple hello, and Hatch gives the man money. Without thinking through the consequences of his actions, Hatch invites Kevin back to his home for a meal, shower, and much-needed sleep."), _c('br'), _c('br'), _vm._v("What transpires between the two men over shared meals and the next few weeks of autumn? Can their different lives come together as a romance begins, and secrets of Kevin’s mysterious life are revealed?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.W. Clinger\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0